var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 230 260",
    enableBackground: "new 0 0 230 260",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.276,218.293l-13.415,2.241l-14.306,4.967l-9.421,1.646l-12.335-4.724l-2.349,3.806l-5.101-1.862l-5.642,8.233 l4.886,5.992l4.724-0.378l20.757,10.986l2.915-0.486l6.155,2.538l3.401,5.074L165.126,258l6.235-8.26l-5.425-8.476l2.618-11.58 L174.276,218.293z M53.295,150.838l-5.912-4.291l-8.017,8.151l-13.064,5.264l4.912,8.071l0.783,32.715l3.293,4.13l4.778,1.971 l4.454-8.449l9.42,1.808l1.674-10.365l1.566-13.55l-2.052-3.536l2.268-11.04L53.295,150.838z M216.547,153.106l-40.894-16.736 l3.509-8.88l-3.482-3.617l-16.654,1.619l-19.678-13.955l-10.77-23.322l-24.024-17.95l-2.51-10.069l2.078-4.237l-1.7-9.34 l21.702-16.843l0.054-0.513l-4.616-12.012l5.021-6.073L103.42,8.262l-5.965-5.911L80.341,2l-2.645,4.805l-9.474-2.214l0.108,8.044 l-4.562-1.943l-5.048,6.505l-14.468,6.505l-2.888,7.342l-8.449-10.743l-10.257,7.801l-5.426-1.215L4.06,30.558l5.101,14.496 l-7.018,8.205l5.453,5.615l-3.59,4.076l3.185,7.801l11.85,4.076l0.027,7.585l8.017-3.671l9.177-11.094l10.905,0.728l18.922,13.416 l0.675,5.992l7.538,17.873l45.908,40l13.334-0.945l5.507,7.342l9.366,7.369l5.318-1.673l5.237,6.748l-1.431,4.049l8.8,5.425 l5.83-1.511l13.55,30.448l-7.018,4.372l1.674,3.806l-5.021,10.906l3.05,4.021l6.56-1.106l1.187-5.021l7.423-8.854l-1.241-6.451 l6.559-5.803l4.265,0.405l-0.081-12.957l-11.718-7.866l7.021-20.126l9.475,4.616l4.912-0.216l6.937,9.07l6.101,2.321l2.051-8.368 L216.547,153.106z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.bc111bf26008ac2cea841e6a67937971.svg";
export { ForwardRef as ReactComponent };